import WhatIDo from './what-i-do'
export default WhatIDo
